import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { reusableGridSort } from '../grid/reusable-grid.function';

import { FocusSelectorSortClosedForTeamGrid } from './closed-for-team-sort.action';

export function focusSelectorSortClosedForTeamGridReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSortClosedForTeamGrid>,
): FocusSelectorState {
    const { column } = action.payload;
    const { sortDefs, defaultSortDefs } = state.recentlyClosedFocusesTeamGrid;
    const nextSortDefs = reusableGridSort(column, sortDefs, defaultSortDefs);

    return {
        ...state,

        recentlyClosedFocusesTeamGrid: {
            ...state.recentlyClosedFocusesTeamGrid,
            sortDefs: nextSortDefs,
        },
    };
}
